import React from 'react';
import LegalDocumentPage from '@/components/LegalDocumentPage';

/**
 * Accessibility Statement — publicly accessible at /accessibility.
 *
 * Phase 117d (Legal Hardening). Standard WCAG 2.1 AA commitment, known
 * limitations, and an accessibility contact — linked from every footer.
 * Body markdown lives in backend/legal_documents.py
 * (ACCESSIBILITY_STATEMENT_MD) and is fetched via
 * GET /api/public/legal/accessibility so the copy has one source of truth.
 */
export default function Accessibility() {
    return <LegalDocumentPage docType="accessibility" />;
}
